<template>
  <div v-show="activeTag!=='快速介绍项目'" class="tags borderbottom">
    <span
      :class="`search_tab_item search_tab_item.tab_item_selected`"
      style="width:100%;background-color:#467388;color:#fff;"
      @click="showtTag('快速介绍项目')"
      >快速介绍项目（点击有惊喜）</span
    >
    <el-tooltip
      v-for="tag in projectTagsResult"
      :key="tag.label"
      :disabled="tag.hasValue"
      effect="dark"
      placement="top">
      <div slot="content">
        暂无信息，点击<i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充
      </div>
      <span
        :class="`search_tab_item ${tabClass(tag)}`"
        @click="showtTag(tag.label)"
        >{{ tag.label }}</span
      >
    </el-tooltip>
    <!-- <span
      v-for="tag in projectTagsResult"
      :key="tag.label"
      :class="`search_tab_item ${tabClass(tag)}`"
      @click="showtTag(tag.label)"
      >{{ tag.label }}</span
    > -->
    <div style="overflow:hidden">
      <span v-if="company._id" class="search_tab_item  tab_item_primary drawer-jump-btn" style="float: left;background-color:#046BB0" @click="toCompany">快捷展示公司</span>
      <span v-if="project._id" class="search_tab_item  tab_item_primary drawer-jump-btn" style="float: right;background-color:#046BB0" @click="toProject">全屏展示</span>
    </div>
  </div>
</template>
<script>
const tags = [
  { label: '岗位补充信息', fields: ['项目亮点及优势', '职位劣势及风险点','部门详情', '阿尔法认知'] },
  { label: '面试辅导', fields: ['面试流程','关键面试人','面试辅导','面试地址word',] },
  { label: '必成单分析', fields: ['职位产生的原因','最迟到岗日期','招聘难点','竞争预警'] },
  { label: '用人画像', fields: ['tagsort','职能模块', '细分职能','擅长方向','地域','目标行业',   '平台', '职级', '业绩','工作年限','学历要求'] },
  { label: '寻访方向', fields: ['寻访方向', '目标公司', '不倾向公司',  '典型人才'] },
  { label: '客户背景', fields: ['一句话简介', '公司优势','人员受认可度', '固定薪酬', '激励机制', '人员稳定性',] },
  { label: '岗位基本信息', fields: ['项目名称', '部门', '行业', '办公地', '关键面试决策人', '保密', '独家', '替换', '新建', '紧急重要', '刚需必成', '岗位描述和岗位要求', '核心要求汇总', '岗位薪酬', '岗位薪酬备注', '最低固薪', '最高固薪', '最低全薪', '最高全薪'] },
  { label: '项目沟通备注', fields: ['remark'] },
  { label: '项目附件', fields: ['附件'] },
  // { label: '岗位JD', fields: ['岗位要求','岗位职责'] },
  // { label: '岗位要求', fields: ['标签分类'] },
  // { label: '岗位要求', fields: ['岗位要求', '岗位薪酬'] },
  // { label: '核心要求', fields: ['核心要求'] },
  // { label: '岗位职责', fields: ['岗位职责'] },
  // { label: '岗位亮点', fields: ['项目亮点及优势','职位劣势及风险点','部门详情','阿尔法认知'] },
  // { label: '项目辅导', fields: ['职位话术', '可能的问题及应对'] },
  // { label: '人才画像分析', fields: ['analyse'] },
  // {
  //   label: '人才画像',
  //   fields: ['职能模块', '细分职能', '平台', '业绩', '擅长方向', '职级', '目标行业', '地域', '标签', '人才画像补充'],
  // },
  // { label: '部门详情', fields: ['部门详情'] },
  // { label: '职位亮点及优势', fields: ['公司亮点及优势', '项目亮点及优势', '职位劣势及风险点'] },
  // { label: '可能的问题及应对', fields: ['可能的问题及应对'] },
]

// const translateTag = {
//   标签: '自定义标签',
//   人才画像补充: '整体情况',
// }

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
    activeTag: { type: String, default: '' },
  },
  data() {
    return {
      projectTagsResult: [],
    }
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        this.computedTags()
      },
      immediate: true,
      deep: true,
    },
    company: {
      handler(newValue, oldValue) {
        this.computedTags()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    toCompany() {
      this.$emit('changeSearch',{type:'公司',keywords:this.project.客户公司})
      // window.open(`${window.origin}#/company/${this.company._id}`)
    },
    toProject() {
      window.open(`${window.origin}#/project20/${this.project._id}?defaultActiveTab=详情`)
    },
    computedTags() {
      const arr = []
      tags.forEach(tag => {
        if(tag.label==='客户背景'){
          const hasValue = this.checkCompanyTagFields(tag.fields)
          const hrHasValue = this.checkTagFields(['对接hr'])
          arr.push({ label: tag.label, hasValue: hasValue || hrHasValue })
        }else{
          const hasValue = this.checkTagFields(tag.fields)
          if (tag.label === '附件') console.log(this.project['附件'], hasValue)
          arr.push({ label: tag.label, hasValue })
        }
      })
      this.projectTagsResult = arr
    },
    checkCompanyTagFields(fields) {
      const { company } = this
      for (const field of fields) {
        const hasValue = this.hasValue(field, company[field])
        if (hasValue) return true
      }
      return false
    },
    checkTagFields(fields) {
      const { project } = this
      for (const field of fields) {
        const hasValue = this.hasValue(field, project[field])
        if (hasValue) return true
      }
      return false
    },
    hasValue(field, value) {
      if (!value) return false
      const specialFields = ['公司亮点', '公司劣势', '业务特点/风格/资源来源']
      if (!specialFields.includes(field)) {
        if (Array.isArray(value) && value.length > 0) return true
        else if (!Array.isArray(value) && value) return true
      } else {
        const { content = '', keywords = {} } = value || {}
        if (content) return true
        const arr = Object.values(keywords)
        return arr.includes(true)
      }
      return false
    },
    tabClass(tag) {
      let result = ''
      if (this.activeTag === tag.label) {
        result += 'tab_item_selected'
      }
      if (tag.hasValue) result += ' tab_item_primary'
      else result += ' tab_item_default'
      return result
    },
    showtTag(label) {
      // this.activeTag = label
      this.$emit('chooseTag', label)
    },
  },
}
</script>
<style scoped>
.borderbottom {
  padding-bottom: 5px;
}
.search_tab_item {
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 8px 0;
  padding: 4px 12px;
  border-radius: 2px;
  min-width: 76px;
  text-align: center;
}
.tab_item_primary {
  color: #fff;
  background-color: #8DB9CE;
}
.search_tab_item.tab_item_default{
  color: #909399;
  background-color: hsla(220,4%,58%,.1);
  text-decoration: line-through;
}
.search_tab_item.tab_item_selected {
  background-color:#4B7A90;
  color:#fff;
}
.drawer-jump-btn {
  background-color: #409eff;
  color: #fff;
}

</style>
